import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { XmlCopySource } from 'app/model/pipeline/copysource/xml.copysource';
import { commonCopySourceAdapts, CopySourceAdapter } from './copysource.adapter';
import { convertStoreSettingsToResource, convertStoreSettingsToModel } from './store-read-settings/store-read-settings.util';
import { convertFormatSettingsToResource, convertFormatSettingsToModel } from './format-read-settings/format-read-settings.util';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(XmlCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class XmlCopySourceAdapter extends CopySourceAdapter<XmlCopySource, Model.XmlSource> {
    protected override async _toResource(copySource: XmlCopySource): Promise<Model.XmlSource> {
        const result: Model.XmlSource = this.getCommonCopySourceProperties(copySource, XmlCopySource.MODEL.name);

        await convertStoreSettingsToResource(copySource.storeSettings, result, this.context);
        await convertFormatSettingsToResource(copySource.formatSettings, result, this.context);

        return result;
    }

    protected override async _toModel(source: Model.XmlSource, copyActivity: CopyActivity): Promise<XmlCopySource> {
        const result = this.createCopySourceWithCommonProperties(XmlCopySource.MODEL, source, copyActivity) as XmlCopySource;

        await convertStoreSettingsToModel(source.storeSettings, result, this.context);
        await convertFormatSettingsToModel(source.formatSettings, result, this.context);
        return result;
    }
}
